/* global swal, */

import './style.less';
import { orderBy, uniqBy, get } from 'lodash';

import createEventModalTemplate from 'modals/createEvent/template.html';
import createEventModalCrtl from 'modals/createEvent/controller.js';

export default function($log, $scope, $stateParams, $q, $state, $uibModal, Swal, CategoryClass, ApiClass, EventClass, ProfileClass) {
  'ngInject';

  this.$onInit = activate;

  const { id, startTime, endTime } = $stateParams;

  const vm = this;

  vm.profileUid = id;

  vm.dates = {
    startDate: new Date(startTime),
    endDate: new Date(endTime)
  };

  vm.tableConfig = {
    isOpen: false,
    select: true,
    fixed_columns_count: 7,
    fixed_columns: {
      type: {
        active: true,
        text: 'Type',
        sort: 'external'
      },
      course: {
        active: true,
        text: 'Course',
        sort: 'course_name'
      },
      delivery_method: {
        active: true,
        text: 'Delivery Method',
        sort: 'delivery_method'
      },
      date: {
        active: true,
        text: 'Date',
        sort: 'sort_date'
      },
      delivery_location: {
        active: true,
        text: 'Location',
        sort: 'delivery_location'
      },
      registration: {
        active: true,
        text: 'Registrations'
      },
      waitlist: {
        active: true,
        text: 'Waitlist'
      },
      certificates: {
        active: false,
        text: 'Credit'
      },
      noCredit: {
        active: false,
        text: 'No Credit'
      }
    },
    license_columns: {},
    selectAll: function() {
      for (const column in this.fixed_columns) {
        this.fixed_columns[column].active = !!this.select; // keep !! for binding
      }

      this.select = !this.select;
      this.fixedColumnCountChange();
    },
    fixedColumnChange: function(column) {
      column.active = !column.active;

      this.fixedColumnCountChange();
    },
    fixedColumnCountChange: function() {
      let tempCount = 1; // start at 1 due to row select

      for (const column in this.fixed_columns) {
        if (this.fixed_columns[column].active) {
          tempCount++;
        }
      }

      this.fixed_columns_count = tempCount;
    }
  };

  vm.updateDates = () => {
    const startTime = vm.dates.startDate && vm.dates.startDate.getTime();
    const endTime = vm.dates.endDate && vm.dates.endDate.getTime();

    $state.go('.', { startTime, endTime }, { reload: true });
  };

  vm.search = '';

  vm.updateReportParams = () => {
    vm.reportParams = {
      date_end: vm.dates.endDate.toISOString(),
      date_start: vm.dates.startDate.toISOString(),
      sponsor_id: vm.sponsor_id
    };
  };

  vm.archiveEvent = function(course_id, event_id) {
    Swal.confirm('Archive Event', 'Are you sure you want to archive this event?', 'warning')
      .then(() => {
        const event = {
          event_id,
          course_id,
          archive: true
        };
        return ApiClass.eventsIdPatch({ id: event_id, manage: true }, { event });
      })
      .then(() => {
        vm.rawCollection = vm.rawCollection.filter(event => event.event_id !== event_id);
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.createEvent = () => {
    $uibModal
      .open({
        size: 'md',
        backdrop: true,
        template: createEventModalTemplate,
        controller: createEventModalCrtl,
        controllerAs: 'createEventCtrl',
        resolve: {
          coursesData: ApiClass.coursesGet(
            { courseType: false },
            {},
            {
              queryParams: {
                internal: true,
                filters: JSON.stringify({
                  deliveryMethods: EventClass.delivery_methods,
                  activeOnly: true,
                  basic: true
                })
              }
            }
          ).then(({ data: { courses } }) => courses)
        }
      })
      .result.then()
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Event Manager Activated');

    const filters = {
      'filters:includePastEvents': true,
      'filters:startTime': $stateParams.startTime,
      'filters:endTime': $stateParams.endTime
    };

    vm.updateReportParams();

    $q.all([
      CategoryClass.loadCategories(),
      ApiClass.eventsGet(
        { eventType: false, pastEvents: true },
        {},
        {
          queryParams: {
            external: true,
            internal: true,
            manage: true,
            ...[
              'certCount',
              'course_id',
              'course_name',
              'delivery_date',
              'delivery_location_time_zone_id',
              'delivery_location',
              'delivery_method',
              'event_id',
              'external',
              'locations',
              'max_participants',
              'noCreditCount',
              'registered',
              'sponsor',
              'tags',
              'waitlisted'
            ].reduce((acc, prop) => {
              acc[`projection:${prop}`] = 1;
              return acc;
            }, {}),
            ...filters
          }
        }
      ),
      // ProfileClass.profileComplete,
    ])
      .then(function([
        category,
        {
          data: { events }
        },
        // profileComplete
      ]) {
        $log.debug('Event Manager Data', arguments);
        $scope.disableButtons = get(ProfileClass.profileComplete, 'company.preferences.read_only.admin.eventManager', false);

        const firmEvents = events.map(event => {
          const { delivery_date, category_id, hours, sponsor } = event;

          if (delivery_date) {
            event.sort_date = new Date(delivery_date).getTime();
          }

          if (category_id) {
            event.subject_area = category.obj[category_id].name;
          }

          if (hours && hours.length) {
            const { creditSum, subject_areas } = hours.reduce(
              (acc, { subject_area, credits }) => {
                acc.creditSum += credits;
                acc.subject_areas.push(subject_area);

                return acc;
              },
              { creditSum: 0, subject_areas: [] }
            );

            event.subject_area = subject_areas.join(', ');
            event.credits = creditSum;
          }

          event.eventReportParams = { event_id: event.event_id };

          event.external = event.external || false;

          if (sponsor) {
            event.sponsor_name = sponsor.name;
            event.sponsor_id = sponsor.sponsor_id;
          } else {
            event.sponsor_id = 'none';
          }

          return event;
        });

        vm.TypeGroup = uniqBy(firmEvents || [], 'delivery_method').map(({ delivery_method }) => delivery_method);
        vm.SponsorGroup = uniqBy(firmEvents || [], event => {
          return event.sponsor && event.sponsor.sponsor_id ? event.sponsor.sponsor_id : undefined;
        }).map(({ sponsor }) => sponsor);

        vm.rawCollection = orderBy(firmEvents, ['sort_date'], ['desc']);
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/controller.js